import Vue from 'vue'
import Vuex from 'vuex'

import account from './module/account'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    account,
  },
  state: {
  },
})
export default store
